import promo from "../../Assests/vid/promo.mp4"
import Toolbar from "../navigation/toolbar/toolbar";
import Footer from "../navigation/footer/footer"
import "./videoAll.css";

export default function Video() {
  return (
    <>
    <Toolbar />    
    <div className="videoAll">
        <h3>Sain et équilibré, le couscous se mange au quotidien et à toutes saisons.</h3><br />
      <video autoPlay="true" object-fit="cover" controls>
        <source src={promo} type="video/mp4" />
        Ton navigateur ne supporte pas la balise vidéo.
      </video>
    </div>
    <Footer />
    </>

  );
}